import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { PriceProvider } from "./PriceContext";   // <-- add this

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PriceProvider>   
      <App />
    </PriceProvider>
  </React.StrictMode>
);
